<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Price:</label>
        <div>
          <input type="text" placeholder="Price" v-model="editPrice" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Logo:</label>
        <div>
          <input type="text" placeholder="Logo" v-model="editLogo" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import * as database from "@/vendor/database";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["propsData"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      buttonLabel: null,
      editType: null,
      submitLoading: false,
      editName: null,
      editPrice: null,
      editLogo: null,
    };
  },
  created: function () {
    this.initData();
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  methods: {
    initData: function () {
      this.editType = this.propsData.type;
      if (this.editType == "add") {
        this.buttonLabel = "Add Software";
      }
      if (this.editType == "edit") {
        this.buttonLabel = "Edit Software";
      }
      this.editName = this.propsData.name;
      this.editPrice = this.propsData.price;
      this.editLogo = this.propsData.logo;
    },
    buttonClick: function () {
      if (this.editName) {
        if (this.editType === "add") {
          this.submitLoading = true;
          database
            .addDoc("software", {
              name: this.editName,
              price: this.editPrice,
              logo: this.editLogo,
            })
            .then((result) => {
              if (result.ok) {
                this.$toasted.global.toast_success({
                  message: "add success",
                });
                this.$emit("closePanel");
              } else {
                this.$toasted.global.toast_error({ message: "add error" });
              }
            })
            .catch((error) => {
              this.$toasted.global.toast_error({ message: error });
            })
            .finally(() => {
              this.submitLoading = false;
            });
        } else {
          this.submitLoading = true;
          database
            .updateDocById("software", this.propsData.id, {
              name: this.editName,
              price: this.editPrice,
              logo: this.editLogo,
            })
            .then((result) => {
              if (result.ok) {
                this.$toasted.global.toast_success({
                  message: "edit success",
                });
                this.$emit("closePanel");
              } else {
                this.$toasted.global.toast_error({ message: "edit error" });
              }
            })
            .catch((error) => {
              this.$toasted.global.toast_error({ message: error });
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      }
    },
  },
};
</script>
